// Fängt Darstellungsfehler ab: Besucher sollen nie eine weiße Seite oder technische Fehlermeldung sehen.
// 1) einmal automatisch neu laden (stellt den Zustand nach Deployments/Netzaussetzern meist wieder her),
// 2) falls es erneut passiert: ruhiger Hinweis ohne Technik-Text mit Link zur Startseite.
// Der Fehler selbst wird weiter von der Sitzungsaufzeichnung (falls eingewilligt) als Marker erfasst.
import React from "react";
import { useLocation } from "react-router-dom";

const KEY = "eb_reload_at";

class Boundary extends React.Component {
  constructor(props) { super(props); this.state = { failed: false }; }
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error) {
    try { console.error("Anzeige-Fehler abgefangen:", error); } catch { /* ignorieren */ }
    let last = 0;
    try { last = parseInt(sessionStorage.getItem(KEY) || "0", 10); } catch { /* ignorieren */ }
    if (Date.now() - last > 60000) {
      try { sessionStorage.setItem(KEY, String(Date.now())); } catch { /* ignorieren */ }
      window.location.reload();
    }
  }
  componentDidUpdate(prev) {
    if (this.state.failed && prev.resetKey !== this.props.resetKey) this.setState({ failed: false }); // anderer Pfad: neu versuchen
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, fontFamily: "var(--font, system-ui, sans-serif)", textAlign: "center", color: "#374151" }}>
        <div>
          <p style={{ fontSize: 16, margin: "0 0 14px" }}>Einen Moment bitte …</p>
          <a href="/" style={{ color: "#2c5cc5", fontWeight: 700, textDecoration: "none" }}>Zur Startseite</a>
        </div>
      </div>
    );
  }
}

export default function ErrorBoundary({ children }) {
  const { pathname } = useLocation();
  return <Boundary resetKey={pathname}>{children}</Boundary>;
}
